/**
 * Compact "receipt" shape written to the local history store when the
 * charging wizard reaches SUMMARY. This is not fake data — every field
 * originates from the backend session (via getCustomerSession) or from
 * SessionContext.state which is itself sourced from live OCPP + backend
 * events.
 */

import { upsertSession } from '../stores/localHistoryStore';

export function recordSessionFromContext(userId, session) {
  if (!userId || !session?.sessionUid) return;

  const record = {
    sessionUid: session.sessionUid,
    stationId: session.stationId || null,
    connectorId: session.connectorId || null,
    stationName: session.stationMeta?.name || null,
    stationLocation: session.stationMeta?.location || null,
    plateRaw: session.vehicle?.licensePlateRaw || null,
    plateNormalized: session.vehicle?.licensePlateNormalized || null,
    billingMode: session.vehicle?.billingMode || session.billingMode || null,
    startedAt: session.live?.startTime || null,
    endedAt: session.live?.endTime || null,
    energyKwh: session.live?.energyKWh ?? null,
    averageKw: session.live?.averageKw ?? null,
    // We store both authorised (pre-auth) and captured amounts so the
    // detail page can render the difference honestly.
    currency: session.currency || session.pricingSnapshot?.currency || 'BBD',
    authorizedCents: session.authorizedAmount ?? null,
    capturedCents: session.payment?.capturedAmount ?? null,
    paymentStatus: session.payment?.status || null,
    // paymentLast4 deliberately NOT persisted — see localHistoryStore for
    // the rationale. Detail page rehydrates it from the backend on demand.
    appliedCredit: session.appliedCredit || null,
    ratePerKwh: session.pricingSnapshot?.rate_per_kwh
      ?? session.stationMeta?.ratePerKwh
      ?? null,
    sessionFee: session.pricingSnapshot?.session_fee
      ?? session.stationMeta?.sessionFee
      ?? null,
    minChargeAmount: session.pricingSnapshot?.min_charge_amount
      ?? session.stationMeta?.minCharge
      ?? null,
    recordedAt: Date.now(),
  };

  upsertSession(userId, record);
}
